module.exports = __webpack_public_path__ + "img/37.1aa5a812.png";